import Modal from "@components/modal";
import React, { useEffect, useState } from "react";
import { Slab, SlabsWrapper, SlabText, Error } from "./styles";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import { resolvePath } from "@utils/resolvePath";
import { getWidgetSpecificProps, sampleAnalytics } from "@utils/index";
import { connect, useSelector } from "react-redux";
import { isEmpty } from "@utils/lodash";
import Banner from "@components/banner";
import { useOnload } from "@utils/useOnLoad";
import { FormatCTAtext } from "@components/mmvNotFoundModal";
import ModalStickyFooter from "@widgets/modalStickyFooter";
import { scrollIntoViewWrapper } from "@utils/index";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const getMaxCommonSlab = (previousSlabs, updatedSlabs) => {
  const prevSlab = previousSlabs?.map((item) => Number(item?.slab));
  const newSlab = updatedSlabs?.map((item) => Number(item?.slab));

  const commonSlabs = prevSlab.filter((slab) => newSlab.includes(slab));

  return commonSlabs?.length ? Math.max(...commonSlabs) : null;
};

const NcbBottomSheet = (props: any) => {
  const {
    options,
    is_visible,
    actions,
    selectedNcb,
    disableOverlayClose,
    hideCloseButton,
    ctaText,
    isUpdateModal,
    errorMessage
  } = props || {};
  const [selectedSlab, setSelectedSlab] = useState<any>();
  const [ncbSlabs, setNcbSlabs] = useState<any>(options);
  const [showError, setShowError] = useState(false);

  const { on_close, on_click, on_load } = actions;

  useOnload({ on_load, is_visible });

  const { updatedNcbSlabs } = useSelector(({ globalState }: any) => {
    return {
      updatedNcbSlabs: globalState?.payloadData?.options
    };
  });

  useEffect(() => {
    if (!isEmpty(updatedNcbSlabs)) {
      const maxNewUpdatedSlab = getMaxCommonSlab(ncbSlabs, updatedNcbSlabs);
      setNcbSlabs(updatedNcbSlabs);
      setSelectedSlab(maxNewUpdatedSlab?.toString());
      if (on_click?.[0] && typeof on_click[0].funCall === "function") {
        on_click?.forEach((eachFunc: any) => {
          eachFunc.funCall({
            data: {
              previous_ncb: String(maxNewUpdatedSlab)
            },
            payloadData: {
              previous_ncb: String(maxNewUpdatedSlab)
            },
            update_props: {
              payloadData: {
                name: "previous_ncb",
                value: String(maxNewUpdatedSlab)
              }
            },
            requestBody: {
              journey: "fresh_car"
            },
            ...eachFunc.args
          });
        });
      }
    }
  }, [updatedNcbSlabs]);

  const handleSlabClick = (slab: any) => {
    sampleAnalytics("action", "tap_btn", "tap_btn_previous_ncb_selected");
    setSelectedSlab(slab);
    setShowError(false);
  };

  useEffect(() => {
    if (
      (!!selectedNcb && !!selectedNcb.toString()) ||
      selectedNcb?.toString() === "0"
    ) {
      setSelectedSlab(selectedNcb.toString());
    }
  }, [selectedNcb]);

  const RenderSlabs = ({ slabs }: any) => {
    return slabs?.map(({ slab, display_text }: any) => {
      return (
        <Slab
          key={slab}
          onClick={() => {
            handleSlabClick(slab);
          }}
          isSelected={selectedSlab === slab}
        >
          <SlabText>
            <span>{slab}%</span> {display_text}
          </SlabText>
        </Slab>
      );
    });
  };

  const closeModal = () => {
    if (on_close?.[0] && typeof on_close[0].funCall === "function") {
      on_close?.forEach((eachFunc: any) => {
        eachFunc.funCall(eachFunc.args);
      });
    }
  };

  const handleContinue = () => {
    if (!isEmpty(selectedSlab)) {
      setShowError(false);
      if (on_click?.[0] && typeof on_click[0].funCall === "function") {
        on_click?.forEach((eachFunc: any) => {
          eachFunc.funCall({
            data: {
              previous_ncb: String(selectedSlab)
            },
            payloadData: {
              previous_ncb: String(selectedSlab)
            },
            update_props: {
              payloadData: {
                name: "previous_ncb",
                value: String(selectedSlab)
              }
            },
            requestBody: {
              journey: "fresh_car"
            },
            ...eachFunc.args
          });
        });
      }
      if (on_close?.[0] && typeof on_close[0].funCall === "function") {
        on_close?.forEach((eachFunc: any) => {
          eachFunc.funCall(eachFunc.args);
        });
      }
    } else {
      setShowError(true);
      scrollIntoViewWrapper("error");
    }
  };

  return (
    <>
      <Modal
        showModal={is_visible}
        setShowModal={closeModal}
        modalHeading={
          isUpdateModal ? (
            <>
              What was the{" "}
              <span style={{ color: "#7C47E1" }}>No Claim Bonus (NCB)</span> in
              your previous policy?
            </>
          ) : (
            <>
              <>Make sure you select the correct NCB</>
            </>
          )
        }
        modalHeadingStyles={{
          color: "#040222",
          fontSize: "20px",
          fontWeight: "600",
          lineHeight: "28px",
          letterSpacing: "-0.1px",
          textAlign: "left",
          boxSizing: "border-box",
          minWidth: "100%",
          ...(isUpdateModal
            ? {
                backgroundImage: `url(${resolvePath("/images/addon-header-gradient.svg")})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                padding: "24px 20px 24px",
                border: "1px solid transparent",
                borderImage:
                  "linear-gradient(90deg, rgba(147, 124, 240, 0.00) 1.46%, #F7BBF5 47%, rgba(147, 124, 240, 0.00) 99.01%)",
                borderWidth: "1px",
                borderStyle: "solid",
                borderImageRepeat: "stretch",
                borderImageSlice: 1
              }
            : {})
        }}
        cueText={
          isUpdateModal
            ? "No Claim Bonus is a reward for good driving and not making any claims. You can check your NCB in your previous policy"
            : ""
        }
        cueTextStyles={
          isUpdateModal
            ? {
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px"
              }
            : {}
        }
        styles={{
          maxWidth: "500px",
          ...(isUpdateModal ? { padding: "0px" } : {})
        }}
        disableOverlayClose={disableOverlayClose}
        hideCloseButton={hideCloseButton}
        wrapperStyles={isUpdateModal ? { padding: "0px" } : {}}
        bodyStyles={isUpdateModal ? { padding: "24px 0px 0px" } : {}}
        showModalFooter
        showPrimaryCta
        primaryCtaText={ctaText || "Continue"}
        primaryCtaClickHandler={() => {
          handleContinue();
        }}
        footerWrapperStyles={
          isUpdateModal ? { padding: "1rem", marginTop: "0px" } : {}
        }
        footerWrapperDStyles={{
          padding: "0px 1.5rem 1.5rem",
          marginTop: "0px"
        }}
      >
        <div
          style={
            isUpdateModal
              ? { padding: "0px 24px 24px", boxSizing: "border-box" }
              : {}
          }
        >
          <Banner
            image={{
              height: 24,
              width: 24,
              imgSrc: resolvePath("/images/icons/warning-icon.svg"),
              alt: "icon"
            }}
            text="If you select the wrong NCB, the discount amount will be <span style = 'font-weight: 600;'>adjusted during claims</span>"
            type="DANGER"
            styles={{
              color: "#040222"
            }}
          />

          <SlabsWrapper showError={showError}>
            <RenderSlabs slabs={ncbSlabs} />
            <div
              id="error"
              style={{ width: "max-content", alignSelf: "flex-start" }}
            >
              {showError && <Error>{errorMessage}</Error>}
            </div>
          </SlabsWrapper>
        </div>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(NcbBottomSheet);
